import axios, { AxiosInstance, AxiosPromise, AxiosResponse, AxiosError } from 'axios';
// eslint-disable-next-line import/no-cycle
import { store } from '../app/store';
import { signOut } from '../features/auth/authSlice';
import { API_URL, Error } from '../const';
import { SubscribeGiftParams } from './types/SubscribeGiftParams';
import { SubscribeGiftPromoCodeParams } from './types/SubscribeGiftPromoCodeParams';
import { Orders } from './types/Orders';
import { SubscribeResponse } from './types/SubscribeResponse';

class Api {
  api: AxiosInstance;

  constructor() {
    this.api = axios.create({
      baseURL: API_URL,
      timeout: 15000,
      validateStatus: (status) => status === 200,
      withCredentials: true,
    });

    const onSuccess = (response: AxiosResponse) => response;
    const onFailure = (error: AxiosError) => {
      const { response } = error;

      if (response && response.status === Error.UNAUTHORIZED) {
        store.dispatch(signOut());
      }

      throw error;
    };

    this.api.interceptors.response.use(onSuccess, onFailure);
  }

  subscribeGift = ({
    senderName,
    recipientName,
    recipientEmail,
    message,
    serviceName,
  }: SubscribeGiftParams): AxiosPromise<SubscribeResponse> =>
    this.api.post('/vasp/subscription/gift', {
      sender_name: senderName,
      recipient_name: recipientName,
      recipient_email: recipientEmail,
      message,
      service_name: serviceName,
    });

  subscribeGiftPromoCode = ({
    promoCode,
    msisdn,
  }: SubscribeGiftPromoCodeParams): AxiosPromise<SubscribeResponse> =>
    this.api.put('/vasp/subscription/gift/activated', {
      promocode: promoCode,
      msisdn,
    });

  getOrders = (): AxiosPromise<{ data: Orders }> => this.api.get('/user/orders');
}

const api = new Api();

export default api;
